<div class="checklist-container">
     @for (item of selfChecks(); track item) {
    <div class="checklist-item" >
        <div>{{item.label}}</div>
        <mat-slide-toggle
              [checked]="item.value"
              [disabled]="item.disabled"
              (change)="toggleChanged(item, $event)"
              color="primary">
        </mat-slide-toggle>
    </div>
    }
</div>
